import { Controller, useFormContext } from "react-hook-form";

import { BannerImageDropzone } from "./banner-image-dropzone";
import { BannerLinkBuilder } from "./banner-link-builder";

import { BannerFormData } from "@/schemas/banner-form.schema";

export const BannerForm = () => {
  const form = useFormContext<BannerFormData>();

  return (
    <div className="flex flex-col gap-5">
      <Controller
        control={form.control}
        name="imageUrl"
        render={({ field, fieldState }) => (
          <BannerImageDropzone
            errorMessage={fieldState.error?.message}
            value={field.value}
            onChange={field.onChange}
          />
        )}
      />

      <BannerLinkBuilder />
    </div>
  );
};
